import {Injectable, inject} from "@angular/core";
import {ResponsiveService} from "../responsive/responsive.service";

@Injectable({providedIn: "root"})
export class GeolocateService {

    private responsiveService: ResponsiveService = inject(ResponsiveService);

    private static readonly MAX_AGE: number = 5 * 60 * 1000;

    public position: GeolocationPosition;

    constructor() {
        console.log("--- GeolocateService");
    }

    /**
     * Get current location, returning a cached version if the elapsed time since getting their location is less than a threshold.
     * @returns {Promise<GeolocationPosition>}
     */
    async getCurrentLocation(timeout: number = 10000): Promise<GeolocationPosition> {
        if (this.responsiveService.isIpad() && this.responsiveService.isIOSChrome()) {
            console.log("Cannot perform location lookup in chrome on iPad");
            return undefined;
        }

        console.log("Looking up current location");

        return new Promise<GeolocationPosition>((resolve, reject) => {
            const timer: ReturnType<typeof setTimeout> = setTimeout(() => {
                reject("Geolocation failed to complete");
            }, timeout + 500);
            navigator.geolocation.getCurrentPosition(
                (position: GeolocationPosition) => {
                    clearTimeout(timer);
                    this.position = position;
                    console.log("Current location from browser: " + this.position.coords.latitude + ", " + this.position.coords.longitude);
                    resolve(this.position);
                },
                (error: GeolocationPositionError) => {
                    clearTimeout(timer);
                    console.log("Unable to determine current location from browser", error);
                    if (this.position) {
                        resolve(this.position);
                    } else {
                        resolve(undefined);
                    }
                },
                {
                    timeout: timeout,
                    enableHighAccuracy: true,
                    maximumAge: GeolocateService.MAX_AGE
                });
        });
    }
}
